import { createContext } from 'react';
import { createIntl, createIntlCache, type IntlShape } from 'react-intl';
import { CORE_NAMESPACES, sourceCore, type CompleteCatalog } from './catalog';
import { decorateIntl } from './intlDecorate';
import { SOURCE_LOCALE, type Locale } from './locales';

export interface I18nValue {
  /** Язык, на котором сейчас показан интерфейс. */
  locale: Locale;
  /** Языки переключателя (`enabledLocales`). */
  locales: readonly Locale[];
  /** Сменить язык: каталоги грузятся, затем интерфейс переключается целиком. */
  setLocale: (locale: Locale) => void;
  /** Загруженные пространства имён текущего языка. */
  namespaces: ReadonlySet<string>;
  /** Попросить пространство имён экрана (повторный вызов ничего не делает). */
  requestNamespace: (namespace: string) => void;
}

/**
 * Рендер без провайдера (тесты компонентов, изолированные кадры) говорит на
 * языке-источнике, а не падает: русское ядро вшито в пакет, а
 * `react-intl` без провайдера бросает исключение на первом же `useIntl`.
 */
export const fallbackIntl: IntlShape = decorateIntl(
  createIntl(
    { locale: SOURCE_LOCALE, defaultLocale: SOURCE_LOCALE, messages: sourceCore() as CompleteCatalog, onError: () => {} },
    createIntlCache(),
  ),
);

export const I18nContext = createContext<I18nValue>({
  locale: SOURCE_LOCALE,
  locales: [SOURCE_LOCALE],
  setLocale: () => {},
  namespaces: new Set(CORE_NAMESPACES),
  requestNamespace: () => {},
});
